import React, { HTMLAttributes, useCallback, useEffect, useMemo, useState } from "react";
import { useRouter } from "next/router";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { Modal, Form, Button, Checkbox, message } from "antd";
import { deepClone } from "@/utils/method";
import axios from "utils/axios";
import { get_balanceTotalWithAiFollow } from "@/api/xt4/balance";
import usePriceCurrencyConvert from "@/hooks/usePriceCurrencyConvert";
import DuihaoImg from "@/assets/images/account/duihao.jpg";
import useNextTick from "@/hooks/useNextTick";
import { delete_userClose } from "@/api/uaapi/user";
import { Modal as AppPasskeyModal } from "@xt/Passkey";
interface AssetsInfoProps {
  totalUsdtAmount: string;
  totalBtcAmount: string;
  totalBtcNetAmount: string;
  assets: {
    SPOT: { totalUsdtAmount: string; totalBtcAmount: string; netBtcAmount: string };
    FUTURES_U: { totalUsdtAmount: string; totalBtcAmount: string; netBtcAmount: string };
    FUTURES_C: { totalUsdtAmount: string; totalBtcAmount: string; netBtcAmount: string };
    LEVER: { totalUsdtAmount: string; totalBtcAmount: string; netBtcAmount: string };
    FINANCE: { totalUsdtAmount: string; totalBtcAmount: string; netBtcAmount: string };
  };
}
interface CloseAccountProps extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
  visible?: boolean;
  title?: string;
  closemodal?(): void;
  modalClassName?: string;
  variant?: "default" | "spikex";
}
const { useTranslation, Trans } = Hooks;
const { debounce, Big, getUrl } = Util;
const { useForm } = Form;
const initForm = { checkbox1: false, checkbox2: false };
type FormDataType = typeof initForm;
const CloseAccount: React.FC<CloseAccountProps> = ({
  className,
  visible = false,
  title = "",
  closemodal,
  modalClassName,
  variant = "default",
}) => {
  const t = useTranslation();
  const [formIns] = useForm();
  const router = useRouter();
  const nextTick = useNextTick();
  //const {isLogin} = store.user;
  // useState
  const [disabled, setDisabled] = useState(false);
  const [assetsInfo, setAssetsInfo] = useState({} as AssetsInfoProps);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ ...initForm });
  const [totalConvertAmount, setTotalConvertAmount] = useState("--");

  const convertRes =
    usePriceCurrencyConvert({
      value: assetsInfo.totalBtcNetAmount || "",
      coin: "btc",
      targetCoin: "usd",
      thousands: false,
      unit: false,
    }) || "--";

  // useEffect
  useEffect(() => {
    if (visible) {
      queryAssetsInfo();
    }
  }, [visible]);

  useEffect(() => {
    if (isNaN(+convertRes)) return setTotalConvertAmount("--");
    if (+convertRes <= 0) {
      return setTotalConvertAmount(Big(convertRes).toFixedCy(2));
    }
    setTotalConvertAmount(convertRes);
  }, [convertRes]);

  useEffect(() => {
    formIns.setFieldsValue({ ...form });
  }, [form]);
  // useMemo
  const disabledForm = useMemo(() => {
    return !Object.values(form).every((ii) => ii !== false);
  }, [form]);

  // method
  const closeModal = () => {
    setForm({ ...initForm });
    closemodal && closemodal();
  };

  const queryAssetsInfo = async () => {
    const { data, err } = await axios.asyncAwait(get_balanceTotalWithAiFollow, {});
    setAssetsInfo(data as AssetsInfoProps);
  };

  const submitform = debounce((faResultId) => {
    formIns.validateFields().then(async (values) => {
      setLoading(true);
      const { data, err } = await axios.asyncAwait(delete_userClose, { params: { faResultId }, successPop: true });
      setLoading(false);
      console.log(err, data, 11111);
      if (!err) {
        console.log(444444);
        store.user.resetStatusToNotLogin();
        // location.href = getUrl("/");

        // message.success(t(data.mc));
        closeModal();
        nextTick(() => {
          router.replace("/accounts/login" + window.location.search);
        });
      }
    });
  });
  const formChange = (changedValues: FormDataType, allValues: FormDataType) => {
    setForm(allValues);
  };

  const [passkeyOpen, setPasskeyOpen] = useState(false);
  const handlePasskeySuccessCallback = useCallback(
    ({ faResultId }) => {
      submitform(faResultId);
    },
    [submitform]
  );

  return (
    <Modal
      open={visible}
      title={title}
      width="500px"
      footer={null}
      className={cx(styles["common_modal"], modalClassName)}
      onCancel={closeModal}
    >
      <div className={cx(styles["closeAccount"], variant === "spikex" && styles.closeAccountSpikex, "modal_content")}>
        <Form form={formIns} name="closeAccountForm" initialValues={initForm} onValuesChange={formChange}>
          <p className={cx(styles["close_tit"])}>{t("account.closeTip")}</p>
          <div className={cx(styles["area_operation"])}>
            <p className={cx(styles["c_tips"])}>
              <img src={DuihaoImg} alt="" className={cx(styles["duihao"])} />
              {t("account.c_tip1")}
            </p>
            <p className={cx(styles["c_tips"])}>
              <img src={DuihaoImg} alt="" className={cx(styles["duihao"])} />
              {t("account.c_tip2")}
            </p>
            <p className={cx(styles["c_tips"])}>
              <img src={DuihaoImg} alt="" className={cx(styles["duihao"])} />
              {t("account.c_tip3")}
            </p>
          </div>
          <p className={cx(styles["close_tit"])}>{t("account.b_tit")}</p>

          <div className={cx(styles["area_operation"])}>
            <p className={cx(styles["c_tips"])}>{t("account.b_tip1")}</p>
            <p className={cx(styles["c_tips"])}>{t("account.b_tip2")}</p>
            <p className={cx(styles["c_tips"])}>{t("account.b_tip3")}</p>
            <p className={cx(styles["c_tips"])}>{t("account.b_tip4")}</p>
            <p className={cx(styles["c_tips"], styles["orange_c_tips"])}>{t("account.b_tip5")}</p>
          </div>

          <div className={cx(styles["check_div"])}>
            <Form.Item name="checkbox1" valuePropName="checked" label="">
              <Checkbox>{t("account.ikonw")}</Checkbox>
            </Form.Item>
            <Form.Item name="checkbox2" valuePropName="checked" label="">
              <Checkbox>
                <Trans
                  i18nKey={"account.iknow2"}
                  values={{ totalConvertAmount }}
                  components={{
                    1: <span style={{ color: "#D94F4F" }}></span>,
                  }}
                ></Trans>
                {/* <span dangerouslySetInnerHTML={{ __html: t("account.iknow2", [totalConvertAmount]) }}></span> */}
              </Checkbox>
            </Form.Item>
          </div>
          <Button
            loading={loading}
            className={cx(styles["closeAccount_btn"], styles["common_button"], disabledForm && styles["disabledBtn"])}
            htmlType="submit"
            onClick={() => setPasskeyOpen(true)}
          >
            {t("account.closeAccount")}
          </Button>
        </Form>
      </div>

      {/* 安全验证 */}
      <AppPasskeyModal
        faBizType={132}
        dynamicCodeType={"USER_2038"}
        successCallback={handlePasskeySuccessCallback}
        open={passkeyOpen}
        onClose={() => setPasskeyOpen(false)}
        isDark={store.app.isDark}
        userInfo={store.user.userInfo}
      />
    </Modal>
  );
};
export default observer(CloseAccount);
